import { render } from "./EphemeridesSwitch.vue?vue&type=template&id=40bb7468"
import script from "./EphemeridesSwitch.vue?vue&type=script&lang=js"
export * from "./EphemeridesSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__